import React, { useState } from "react";
import { useBooks } from "@/context/BookContext";
import { BookOpen, CaretDown, Check } from "@phosphor-icons/react";
import { Link } from "react-router-dom";

export default function BookSelector({ testid = "book-selector" }) {
  const { books, activeId, setActive } = useBooks();
  const [open, setOpen] = useState(false);

  const active = books.find((b) => b.id === activeId);

  return (
    <div className="relative" data-testid={testid}>
      <button
        onClick={() => setOpen((v) => !v)}
        className="brut-btn brut-btn-secondary flex items-center gap-2 text-sm"
        data-testid={`${testid}-trigger`}
      >
        <BookOpen size={16} weight="bold" color="#2cb4a6" />
        <span className="font-bold">{active ? active.name : "No book"}</span>
        <CaretDown size={12} weight="bold" />
      </button>
      {open && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setOpen(false)} />
          <div
            className="absolute right-0 mt-1 z-50 bg-white border-2 border-[#0f1b4c] shadow-[4px_4px_0_#0f1b4c] w-64"
            data-testid={`${testid}-menu`}
          >
            {books.map((b) => (
              <button
                key={b.id}
                onClick={() => { setActive(b.id); setOpen(false); }}
                data-testid={`${testid}-option-${b.id}`}
                className={`w-full flex items-center justify-between gap-3 px-4 py-3 text-left hover:bg-[#f4f7fb] border-b border-[#0f1b4c]/10 last:border-b-0 ${
                  b.id === activeId ? "bg-[#f4f7fb]" : ""
                }`}
              >
                <div>
                  <div className="font-bold text-sm">{b.name}</div>
                  <div className="text-[10px] uppercase tracking-widest text-[#4a5578]">
                    {b.transaction_count} entries {b.is_default ? "· default" : ""}
                  </div>
                </div>
                {b.id === activeId && <Check size={16} weight="bold" color="#2cb4a6" />}
              </button>
            ))}
            <Link
              to="/books"
              onClick={() => setOpen(false)}
              className="w-full block px-4 py-3 text-center text-xs font-bold uppercase tracking-widest text-[#1e2a6b] bg-[#e6ecf5] hover:bg-[#d3dbe8]"
              data-testid={`${testid}-manage`}
            >
              Manage books →
            </Link>
          </div>
        </>
      )}
    </div>
  );
}
